

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { formatarMoeda } from '@/shareds/formatadores'

@Component
export default class SecaoDemonstracoes extends Vue {
	@Prop({ type: Array, default: () => [] }) items!: any[]
	@Prop({ type: Boolean, default: false }) loading!: boolean
	@Prop({ type: String, default: '' }) atualizadoEm!: string

	headers = [
		{ text: 'Vendedor', value: 'vendedor', sortable: false },
		{ text: 'Cliente', value: 'cliente', sortable: false, align: 'end' },
		{ text: 'Total em aberto', value: 'total', sortable: false, align: 'end' },
		{ text: 'Preço médio', value: 'precoMedio', sortable: false, align: 'end' },
		{ text: 'QTD peças', value: 'quantidade', sortable: false, align: 'end' },
		{ text: 'Dias em aberto', value: 'diasEmAberto', sortable: false, align: 'end' },
		{ text: 'Nota fiscal', value: 'notaFiscal', sortable: false, align: 'end' },
		{ text: 'Identificador', value: 'identificador', sortable: false, align: 'end' },
	]

	toNumber(v: any): number {
		if (typeof v === 'number') return v
		const n = Number(v)
		return isNaN(n) ? 0 : n
	}
	moeda(v: any): string { return 'R$ ' + formatarMoeda(this.toNumber(v)) }

	somaCampo(itens: any[], campo: string): number {
		return itens.reduce((s, i) => s + this.toNumber(i[campo]), 0)
	}
	mediaCampo(itens: any[], campo: string): number {
		if (!itens.length) return 0
		return this.somaCampo(itens, campo) / itens.length
	}
	maxCampo(itens: any[], campo: string): number {
		return itens.reduce((m, i) => Math.max(m, this.toNumber(i[campo])), 0)
	}

	itensDoGrupo(group: any): any[] {
		return this.items.filter(i => (i.vendedor || '') === (group || ''))
	}

	irPara(identificador: string) {
		const filtro = {
			busca: '', lojaId: '', datas: [null, null], horas: [null, null], cliente: null,
			pdvId: '', numeroDaNota: '', serieFiscal: '', exibeVendasComErros: false,
			ambientes: ['Homologação', 'Produção'], identificador, identificadorExterno: '',
			vendasComOrcamento: false, vendasComPagamentoCancelado: false, origem: null,
		}
		localStorage.setItem('FILTRO_DE_VENDAS', JSON.stringify(filtro))
		window.open('/vendas', '_blank')
	}
}
